import React, { useState, useEffect } from 'react'
import { Card, Col, Container } from 'reactstrap'
import moment from 'moment';
// actions
import { getLabTests, updateLabTest, addNewLabTest, deleteLabTest, updateLabTestStatus } from "../../../store/catalogs/LabTests/actions"
import { addNewLabTestSample, deleteLabTestSample } from "../../../store/catalogs/LabTestSamples/actions"
import { getLabAreas } from "../../../store/catalogs/LabAreas/actions"
import { getNorms } from "../../../store/catalogs/Norms/actions"
import { getUnitMeasures } from "../../../store/catalogs/UnitMeasures/actions"
import { useSelector, useDispatch } from "react-redux";
import { LabEssayRegisterModal } from './LabEssayRegisterModal';
import { SampleEssayRegisterModal } from './SampleEssayRegisterModal';


import Table1 from "../../../components/Common/TableContainer"
import TableNP from "../../../components/Common/TableContainerNP"
import { SearchBar } from '../../../components/Common/SearchBar'
import { BackButton } from '../../../components/Common/BackButton'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { Expander } from '../../../components/Common/Expander'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"

export const CatalogLayoutEssays = (props) => {

    // Modal HOOKS
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [showModal4, setShowModal4] = useState(false);
    
    const [isUpdate, setIsUpdate] = useState(false);
    const [isUpdate2, setIsUpdate2] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [rowInfo2, setRowInfo2] = useState();
    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getLabTests(`?limit=20&page=0&recordStatus=all&search=${searchData}`))
    }, [searchData])

    // * Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getLabTests("?limit=20&recordStatus=all&page=0"))
        dispatch(getLabAreas("?limit=4000&page=0"))
        dispatch(getNorms("?limit=4000&page=0"))
        dispatch(getUnitMeasures("?limit=4000&page=0"))
    }, [])

    const { labTests, loading, total, currentPage, labAreas, norms, unitmeasures } = useSelector(state => ({
        labTests: state.labTest.labTests,
        loading: state.labTest.loading,
        labTest: state.labTest.labTest,
        total: state.labTest.total,
        currentPage: state.labTest.currentPage,
        labAreas: state.labAreas.labareas,
        norms: state.norms.norms,
        unitmeasures: state.unitMeasures.unitmeasures,
    }));
    // * Redux fin

    const reRender = () => {
        dispatch(getLabTests("?limit=20&page=0&recordStatus=all"));
    }

    const getPagination = (params) => {
        dispatch(getLabTests(`${params}&search=${searchData}&recordStatus=all`))
    }

    const modalClose = () => {
        setIsUpdate(false)
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteLabTest(rowInfo))
        setRowInfo('')
    }

    const onDeleteSampleConfirmation = () => {
        dispatch(deleteLabTestSample(rowInfo2))
        setRowInfo2('')
        setTimeout(reRender, 500);
    }

    const columns = React.useMemo(
        () => [
            Expander,
            {
                Header: 'Información de laboratorio',
                width: '16%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>Área de Laboratorio: {row.original.laboratoryArea?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Información del ensayo',
                width: "16%",
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>Método de Ensayo: {row.original.method ?? '-'}</div>
                        <hr />
                        <div className='text-left'>Nombre de Ensayo: {row.original.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Información de norma',
                width: "16%",
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>Norma: {row.original.norm.name ?? '-'}</div>
                        <hr />
                        <div className='text-left'>Descripción de Norma: {row.original.norm.description ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Costos de ensayos',
                width: "14%",
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>Materiales: ${row.original.materialCost ?? '-'}</div>
                        <hr />
                        <div className='text-left'>Mano de Obra: ${row.original.workforceCost ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Costos total de ensayos',
                width: "12%",
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>Costo total de ensayo: ${row.original.totalCost ?? '-'}</div>
                        <hr />
                        <div className='text-left'>Costo total de terceros: ${row.original.thirdCost ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Fecha última actualización',
                width: "9%",
                Cell: ({ row }) => (
                    <div>
                        <div className='text-center'>{row.original.updatedAt ? moment(row.original.updatedAt).format("DD-MM-YYYY") : '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Estatus',
                width: "9%",
                Cell: ({ row }) => (
                    row.original.recordStatus == true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}> <span className="mdi mdi-18px mdi-lead-pencil p-2"></span> </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}> <span className="mdi mdi-18px mdi-delete p-2"></span> </button>
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0" onClick={() => { onAddTest(row.original) }}> <span className="mdi mdi-18px mdi-plus-circle-outline p-2"></span> </button>
                    </div>
                ),
            },
        ],
        []
    )

    const columns2 = React.useMemo(
        () => [
            {
                Header: 'Descripción de la muestra',
                width: '20%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.description ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Cantidad',
                width: "16%",
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.quantity ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Unidad de Medida',
                width: "16%",
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.unitMeasure?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDeleteSample(row.original) }}> <span className="mdi mdi-18px mdi-delete p-2"></span> </button>
                    </div>
                ),
            },
        ],
        []
    )

    const callback = React.useCallback(
        ({ row }) => (
            <TableNP isAddTableBorderStrap columns={columns2} data={row.original.labTestsSamples ?? []} />
        ),
        []
    )

    const renderRowSubComponent = (row) => {
        callback(row)
    }

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onAddTest = (values) => {
        setRowInfo(values)
        setShowModal3(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const onDeleteSample = (values) => {
        setRowInfo2(values)
        setShowModal4(true)
    }

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            dispatch(updateLabTest(updValue));
            dispatch(updateLabTestStatus({
                id: rowInfo.id,
                recordStatus: active,
            }));
            dispatch(getLabTests("?limit=20&page=0&recordStatus=all"))
        } else {
            dispatch(addNewLabTest(values))
            setTimeout(reRender, 500);
        }
        setIsUpdate(false)
        setRowInfo('')
    }

    const RegisterTestsSamples = (values) => {
        if (isUpdate2) {
            dispatch(updateLabTest({ ...values, id: rowInfo.id }));
        } else {
            dispatch(addNewLabTestSample(values));
        }
        setTimeout(() => {
            dispatch(getLabTests("?limit=20&page=0&recordStatus=all"));
        }, 500);
        setIsUpdate(false);
        setRowInfo('');
    };    

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='EssaysCatalog' />

                            <Card className='' style={{ padding: 20 }}>

                                <div className='pe-1'>
                                    <BackButton props={props} />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                        <SearchBar setSearchData={setSearchData} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                        <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <Table1 renderRowSubComponent={callback} currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labTests} />
                                </div>

                                <LabEssayRegisterModal
                                    setShowModal={setShowModal1}
                                    showModal={showModal1}
                                    norms={norms}
                                    labAreas={labAreas}
                                    rowInfo={rowInfo}
                                    modalClose={modalClose}
                                    isUpdate={isUpdate}
                                    modalRespInfo={RegisterModalRespInfo}
                                />

                                <SampleEssayRegisterModal
                                    setShowModal={setShowModal3}
                                    showModal={showModal3}
                                    unitMeasures={unitmeasures}
                                    rowInfo={rowInfo}
                                    modalClose={modalClose}
                                    isUpdate={isUpdate2}
                                    modalRespInfo={RegisterTestsSamples}
                                />

                                <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar ensayos de laboratorio' modalBodyLabel='¿Está seguro que desea eliminar el ensayo de laboratorio seleccionado?' />
                                <TableItemDeleteModal onDeleteConfirmation={onDeleteSampleConfirmation} props={props} setShowModal={setShowModal4} showModal={showModal4} modalHeader='Eliminar muestra de ensayo de laboratorio' modalBodyLabel='¿Está seguro que desea eliminar la muestra de ensayo de laboratorio seleccionado?' />
                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </React.Fragment>
    )
}
